import { RIFFFile } from "riff-file";
import { unpackArray, unpackString } from "byte-data";
const DWORD = { bits: 32, be: false, signed: false, fp: false };
export function parseAni(arr) {
    const riff = new RIFFFile();
    riff.setSignature(arr);
    const signature = riff.signature;
    if (signature.format !== "ACON") {
        throw new Error(`Expected format. Expected "ACON", got "${signature.format}"`);
    }
    // Helper function to get a chunk by chunkId and transform it if it's non-null.
    function mapChunk(chunkId, mapper) {
        const chunk = riff.findChunk(chunkId);
        return chunk == null ? null : mapper(chunk);
    }
    function readImages(chunk, frameCount) {
        return chunk.subChunks.slice(0, frameCount).map((c) => {
            if (c.chunkId !== "icon") {
                throw new Error(`Unexpected chunk type in fram: ${c.chunkId}`);
            }
            return arr.slice(c.chunkData.start, c.chunkData.end);
        });
    }
    const metadata = mapChunk("anih", (c) => {
        const words = unpackArray(arr, DWORD, c.chunkData.start, c.chunkData.end);
        return {
            cbSize: words[0],
            nFrames: words[1],
            nSteps: words[2],
            iWidth: words[3],
            iHeight: words[4],
            iBitCount: words[5],
            nPlanes: words[6],
            iDispRate: words[7],
            bfAttributes: words[8],
        };
    });
    if (metadata == null) {
        throw new Error("Did not find anih");
    }
    const rate = mapChunk("rate", (c) => {
        return unpackArray(arr, DWORD, c.chunkData.start, c.chunkData.end);
    });
    // chunkIds are always four chars, hence the trailing space.
    const seq = mapChunk("seq ", (c) => {
        return unpackArray(arr, DWORD, c.chunkData.start, c.chunkData.end);
    });
    const lists = riff.findChunk("LIST", true);
    const imageChunk = lists === null || lists === void 0 ? void 0 : lists.find((c) => c.format === "fram");
    if (imageChunk == null) {
        throw new Error("Did not find fram LIST");
    }
    let images = readImages(imageChunk, metadata.nFrames);
    let title = null;
    let artist = null;
    const infoChunk = lists === null || lists === void 0 ? void 0 : lists.find((c) => c.format === "INFO");
    if (infoChunk != null) {
        infoChunk.subChunks.forEach((c) => {
            switch (c.chunkId) {
                case "INAM":
                    title = unpackString(arr, c.chunkData.start, c.chunkData.end);
                    break;
                case "IART":
                    artist = unpackString(arr, c.chunkData.start, c.chunkData.end);
                    break;
                case "LIST":
                    // Some cursors with an artist of "Created with Take ONE 3.5 (unregisterred version)" seem to have their frames here for some reason?
                    if (c.format === "fram") {
                        images = readImages(c, metadata.nFrames);
                    }
                    break;
                default:
                // Unexpected subchunk
            }
        });
    }
    return { images, rate, seq, metadata, artist, title };
}
//# sourceMappingURL=parser.js.map